export enum SidePanelMode {
  NOTES,
  READABILITY,
  BOOKMARKS,
  POLLY,
  SEARCH,
  DEVELOPMENT
}
